import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { courseFinancesApi } from "./courseFinancesApi";

export const useCourseFinancesByCourseId = (courseId: number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_FINANCES(courseId),
    queryFn: () => courseFinancesApi.fetchByCourseId(Number(courseId)),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_FINANCES(courseId),
    });
  };

  return { invalidate, isLoading, isFetching, courseFinances: data?.data ?? [] };
};
